module.exports = __webpack_public_path__ + "static/media/woo9.b3994a6b.png";